import { jsx as C } from "react/jsx-runtime";
const o = () => /* @__PURE__ */ C(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.584 6.82125C21.3124 7.30689 21.75 8.12448 21.75 8.99999V19C21.75 20.5188 20.5188 21.75 19 21.75H17.5V19.75C17.5 17.1266 15.3734 15 12.75 15H11.75C9.12665 15 7 17.1266 7 19.75V21.75H5C3.48122 21.75 2.25 20.5188 2.25 19V8.99999C2.25 8.12448 2.68756 7.30689 3.41603 6.82125L10.4746 2.11555C11.3983 1.49973 12.6017 1.49973 13.5254 2.11555L20.584 6.82125ZM16 19.75V21.75H8.5V19.75C8.5 17.9551 9.95507 16.5 11.75 16.5H12.75C14.5449 16.5 16 17.9551 16 19.75ZM10.5 10.25C10.5 9.2835 11.2835 8.5 12.25 8.5C13.2165 8.5 14 9.2835 14 10.25C14 11.2165 13.2165 12 12.25 12C11.2835 12 10.5 11.2165 10.5 10.25ZM12.25 7C10.4551 7 9 8.45507 9 10.25C9 12.0449 10.4551 13.5 12.25 13.5C14.0449 13.5 15.5 12.0449 15.5 10.25C15.5 8.45507 14.0449 7 12.25 7Z",
    fill: "currentColor"
  }
);
export {
  o as default
};
